import { combineReducers } from "@reduxjs/toolkit";
import LogoutSlice from "./LogoutSlice";

export const AccountReducers = combineReducers({
	Logout: LogoutSlice
});
